import { api } from '@/helpers/api'
import { makeObservable, observable, runInAction } from 'mobx'

class AdminService {
  @observable userData: ServerData.Admin.UserInfo | null = null
  @observable menus: ServerData.Admin.MenuItemData[] = []
  @observable menusLoaded = false
  constructor() {
    makeObservable(this)
  }

  public init() {}

  public async getUserInfo(force: boolean = false) {
    try {
      if (force) {
        const { data } = await api.admin.getUserInfo()
        console.error(data ,'ddd')
        runInAction(() => {
          if (data) {
            this.userData = data
          }
        })
      }
      return this.userData
    } catch (error) {
      console.error('获取用户信息失败:', error)
    }
  }

  public async logout() {
    try {
      await api.admin.logout()
      runInAction(() => {
        this.userData = null
        this.menus = []
        this.menusLoaded = false
      })
    } catch (error) {
      console.error('退出登录失败:', error)
    }
  }
}
export const adminService = new AdminService()
